export const environment = {
  apiUrl: 'https://localhost:7203',
  azureAd: {
    scopes: ['User.Read', 'Group.Read.All']
  }
};
